(function(){
  function initSurfaceTransitions(){
    if(window.__vsSurfaceTransitionsReady){return;}
    window.__vsSurfaceTransitionsReady=true;

    var specs=[
      ['.vs-overview','var(--vs-blue)'],
      ['.vs-framework-lite','var(--vs-cream)'],
      ['.vs-entry-path','var(--vs-blue)'],
      ['#founder','var(--vs-cream)'],
      ['.vs-clients','var(--vs-blue)'],
      ['#contact','var(--vs-cream)']
    ];

    var targets=[];

    specs.forEach(function(spec){
      var el=document.querySelector(spec[0]);
      if(!el){return;}
      el.classList.add('vs-surface-transition-target');

      var layer=el.querySelector(':scope > .vs-surface-dissolve');
      if(!layer){
        layer=document.createElement('div');
        layer.className='vs-surface-dissolve';
        layer.setAttribute('aria-hidden','true');
        el.insertBefore(layer,el.firstChild);
      }

      layer.style.setProperty('--vs-dissolve-from',spec[1]);
      targets.push({el:el,layer:layer});
    });

    var raf=0;
    function clamp(v){return Math.max(0,Math.min(1,v));}
    function smooth(v){return v*v*(3-2*v);}

    function update(){
      raf=0;

      if(window.innerWidth<=1100 && window.innerWidth>680){
        targets.forEach(function(item){
          item.layer.style.setProperty('--vs-dissolve-opacity','0');
        });
        return;
      }

      var vh=window.innerHeight||document.documentElement.clientHeight;

      targets.forEach(function(item){
        var rect=item.el.getBoundingClientRect();
        var start=vh*.98;
        var end=vh*.30;
        var progress=clamp((start-rect.top)/(start-end));
        var opacity=1-smooth(progress);
        item.layer.style.setProperty('--vs-dissolve-opacity',opacity.toFixed(4));
      });
    }

    function requestUpdate(){
      if(raf){return;}
      raf=requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll',requestUpdate,{passive:true});
    window.addEventListener('resize',requestUpdate,{passive:true});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initSurfaceTransitions,{once:true});
  }else{
    initSurfaceTransitions();
  }

  document.addEventListener('shopify:section:load',function(){
    window.__vsSurfaceTransitionsReady=false;
    initSurfaceTransitions();
  });
})();